import { useQuery } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export function useGetFileUrl({ documentId }: { documentId: string }) {
  const fetchRequest = useFetch<GetFileRes>()
  const url = `/files/${documentId}`
  return useQuery({
    queryKey: [url],
    queryFn: () => fetchRequest(`${apiBase()}${url}`),
    enabled: false,
  })
}

export interface GetFileRes {
  signedUrl: string
  _id: string
  hash: string
  type: string
  name: string
  title: string
  pool: null[]
  uploadedDate: Date
  uploadedBy: string
  subtype: string
}
